import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1842_581)" }, [
      _createElementVNode("path", {
        d: "M7 12.6C8.48519 12.6 9.90962 12.01 10.9598 10.9598C12.01 9.90962 12.6 8.48519 12.6 7C12.6 5.51479 12.01 4.09041 10.9598 3.04021C9.90962 1.99 8.48519 1.4 7 1.4C5.51479 1.4 4.09041 1.99 3.04021 3.04021C1.99 4.09041 1.4 5.51479 1.4 7C1.4 8.48519 1.99 9.90962 3.04021 10.9598C4.09041 12.01 5.51479 12.6 7 12.6ZM7 14C3.1339 14 0 10.8661 0 7C0 3.1339 3.1339 0 7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14ZM7 9.8C7.74263 9.8 8.45481 9.50502 8.97988 8.97988C9.50502 8.45481 9.8 7.74263 9.8 7C9.8 6.25737 9.50502 5.5452 8.97988 5.0201C8.45481 4.495 7.74263 4.2 7 4.2C6.25737 4.2 5.5452 4.495 5.0201 5.0201C4.495 5.5452 4.2 6.25737 4.2 7C4.2 7.74263 4.495 8.45481 5.0201 8.97988C5.5452 9.50502 6.25737 9.8 7 9.8ZM7 11.2C5.88609 11.2 4.81781 10.7575 4.03015 9.96982C3.2425 9.18218 2.8 8.11391 2.8 7C2.8 5.88609 3.2425 4.81781 4.03015 4.03015C4.81781 3.2425 5.88609 2.8 7 2.8C8.11391 2.8 9.18218 3.2425 9.96982 4.03015C10.7575 4.81781 11.2 5.88609 11.2 7C11.2 8.11391 10.7575 9.18218 9.96982 9.96982C9.18218 10.7575 8.11391 11.2 7 11.2ZM7 8.4C6.62872 8.4 6.27263 8.25251 6.01006 7.98994C5.74749 7.72737 5.6 7.37128 5.6 7C5.6 6.62872 5.74749 6.27263 6.01006 6.01006C6.27263 5.74749 6.62872 5.6 7 5.6C7.37128 5.6 7.72737 5.74749 7.98994 6.01006C8.25251 6.27263 8.4 6.62872 8.4 7C8.4 7.37128 8.25251 7.72737 7.98994 7.98994C7.72737 8.25251 7.37128 8.4 7 8.4Z",
        fill: "#FFE400"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_1842_581" }, [
        _createElementVNode("rect", {
          width: "14",
          height: "14",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}